module.exports = __webpack_public_path__ + "img/call-calling.4e168228.svg";